const o = {
  name: "Tooltip",
  dimensions: { width: 22, height: 23 },
  content: `
    <g clip-path="url(#clip0_3573_137)">
      <path d="M11 21.75C16.5228 21.75 21 17.2728 21 11.75C21 6.22715 16.5228 1.75 11 1.75C5.47715 1.75 1 6.22715 1 11.75C1 17.2728 5.47715 21.75 11 21.75Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.08984 8.75008C8.32495 8.08175 8.789 7.51819 9.3998 7.15921C10.0106 6.80024 10.7287 6.66902 11.427 6.78879C12.1253 6.90857 12.7587 7.27161 13.2149 7.81361C13.4999 8.15212 13.9198 8.75 13.9198 9.75008C13.9198 11.7501 10.9198 12.7501 10.9198 12.7501V13.75" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11 16.75H11.01" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_3573_137">
        <rect width="22" height="22" fill="white" transform="translate(0 0.75)"/>
      </clipPath>
    </defs>
  `
};
export {
  o as Tooltip
};
